export default __webpack_public_path__ + "3ddc6f98ad0c533fdfeae7a992a6cd5a.svg";